import GetQuotesButton from './get-quotes-button.jsx';

export { GetQuotesButton };


// WEBPACK FOOTER //
// ./components/partials/get-quotes-button/index.js